import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../state/hooks'
import {
  selectSaleCustomer,
  setFulfilmentDetails,
} from '../../../../../state/slices/currentSale/currentSaleSlice'
import { generateAddressDetailsFromCustomer } from '../fulfillmentHelper'
import { FulfilmentDetail } from '../../../../../models/fulfilment'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { FEATURE_CAPTURE_ADDRESS_SELL_SCREEN } from '../../../../../constants'

export const useAutoPopulateFulfillmentAddresses = (
  fulfilmentDetail?: FulfilmentDetail
) => {
  const dispatch = useAppDispatch()
  const saleCustomer = useAppSelector(selectSaleCustomer)
  const isCaptureAddressSellScreenEnabled = getFeatureFromCache(
    FEATURE_CAPTURE_ADDRESS_SELL_SCREEN
  )

  const customerAddress = React.useMemo(() => {
    return saleCustomer
      ? generateAddressDetailsFromCustomer(saleCustomer)
      : undefined
  }, [saleCustomer])

  React.useEffect(() => {
    if (
      !fulfilmentDetail ||
      !customerAddress ||
      !isCaptureAddressSellScreenEnabled
    )
      return

    const updatedDetail = { ...fulfilmentDetail }
    let shouldUpdate = false

    if (!fulfilmentDetail.shippingAddress && customerAddress.shippingAddress) {
      updatedDetail.shippingAddress = customerAddress.shippingAddress
      shouldUpdate = true
    }

    if (!fulfilmentDetail.billingAddress && customerAddress.billingAddress) {
      updatedDetail.billingAddress = customerAddress.billingAddress
      shouldUpdate = true
    }

    if (shouldUpdate) {
      dispatch(setFulfilmentDetails([updatedDetail]))
    }
  }, [
    fulfilmentDetail,
    customerAddress,
    dispatch,
    isCaptureAddressSellScreenEnabled,
  ])
}
